import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
const Metatags = () => {
  const location = useLocation();

  // Define metadata for different pages
  const metadata = {
    "/": {
      title: "Managing AI Quality and Risks with Agentic Workflows - AgentRAI",
      description:
        "Agent RAI enables organizations to measure the quality, trustworthiness, and risks of an Agentic AI system with real-time scoring of models and applications.",
      image: "https://www.elixirclaw.ai/hubfs/agent-rai-feature-image.png",
      url: "https://www.agentrai.ai/",
      favicon: "/agentrai-logo-elixirclaw.svg",
    },
    "/agenttrust": {
      title:
        "Agent Trust - Measuring AI Integrity for Confident Decision-Making",
      description:
        "Agent Trust provides an AI Trust Score, a comprehensive metric that evaluates the reliability, fairness, and security of AI systems, ensuring ethical and responsible AI adoption.",
      image: "https://www.elixirclaw.ai/hubfs/agent-trust-score-feature-image.svg",
      url: "https://www.agenttrust.ai/",
      favicon: "/agent-trust-favicon.svg",
    },
  };

  const currentMeta = metadata[location.pathname] || metadata["/"];
  useEffect(() => {
    const favicon = document.querySelector("link[rel='icon']");
    if (favicon) {
      favicon.href = currentMeta.favicon;
    }
  }, [currentMeta.favicon]);
  return (
    <Helmet>
      <title>{currentMeta.title}</title>
      <meta name="description" content={currentMeta.description} />
      {/* Open Graph Meta Tags */}
      <meta property="og:type" content="web page" />
      <meta property="og:image" content={currentMeta.image} />
      <meta property="og:url" content={currentMeta.url} />
      <meta property="og:description" content={currentMeta.description} />
      <meta property="og:title" content={currentMeta.title} />
      {/* Twitter Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      {/* <meta name="twitter:site" content="https://x.com/akira_xai" /> */}
      <meta name="twitter:description" content={currentMeta.description} />
      <meta name="twitter:title" content={currentMeta.title} />
      {/* Favicons */}
      <link rel="icon" href={currentMeta.favicon} />
      <link rel="apple-touch-icon" href="/logo192.png" />
    </Helmet>
  );
};

export default Metatags;
